@let search = store.searchConfigSg();

@if (search) {
  <atn-ds-search
    [config]="search.options"
    [value]="search.value"
    (valueChange)="store.changeSearch($event)"
  />
}

<atn-ds-table-data />

@if (store.paginationConfigSg()) {
  <atn-ds-table-pagination />
}
